import * as React from 'react';
import { observer } from 'mobx-react';
import { Row } from '@estee/elc-grid';
import { DEFAULT_GRID_BREAKPOINTS } from '~constants/ProductGrid';
import { GridItem } from '../../domain/entities/GridItem';
import { classes } from '../../utils/Classes';
import { ResponsiveGridWrapper } from '../../utils/ResponsiveGridWrapper';
import { getColumnsWidth } from '../../utils/ResponsiveColumnsWidth';
import { IBreakpoints } from '../../interfaces/IBreakpoints';
import { configConsumer } from '@estee/elc-service';
import { IOrderConfigCollection } from '../../interfaces/IOrderableComponents';
import { ProductBriefViewContent } from './ProductBriefViewContent';

export interface IProductBriefCollectionConfig {
    productGridBreakpoints?: IBreakpoints;
    ctaType?: string;
    toutWidth?: number;
    toutHeight?: number;
    enableGridCarousel?: boolean;
    featuredProductOverrideImage?: string;
    componentElementsOrderConfig?: { [key: string]: IOrderConfigCollection };
}
export interface IProductBriefCollection {
    config?: IProductBriefCollectionConfig;
    className?: string;
    featuredProductId?: string;
    isAllGiftsFilterApplied?: boolean;
    isLoaded: boolean;
    isMobile?: boolean;
    areFiltersApplied?: boolean;
    gridItems: GridItem[];
    positionGridInsideAccordion?: boolean;
}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IProductBriefCollectionWrapper extends Omit<IProductBriefCollection, 'isMobile'> {}

export const ProductBriefCollection = configConsumer([
    'productGridBreakpoints',
    'enableGridCarousel',
    'featuredProductOverrideImage',
    'componentElementsOrderConfig'
])(
    observer(function ProductBriefCollection(props: IProductBriefCollection) {
        const {
            config: {
                enableGridCarousel,
                productGridBreakpoints: breakpoints = DEFAULT_GRID_BREAKPOINTS
            } = {},
            isMobile,
            isLoaded,
            gridItems,
            areFiltersApplied
        } = props;

        const productBriefViewClassNames = classes('product-brief-view', props.className, `number-column-mobile-${breakpoints.numColumnsMobile}`);
        const carouselWrapperRowClassNames = classes('carousel-wrapper-row');

        return (
            <ResponsiveGridWrapper
                breakpoints={getColumnsWidth(breakpoints)}
                className={productBriefViewClassNames}
            >
                {enableGridCarousel || !isLoaded ? (
                    <Row className={carouselWrapperRowClassNames}>
                        <ProductBriefViewContent
                            breakpoints={breakpoints}
                            gridItems={gridItems}
                            isMobile={isMobile}
                            isLoaded={isLoaded}
                            areFiltersApplied={areFiltersApplied}
                        />
                    </Row>
                ) : (
                    <ProductBriefViewContent
                        breakpoints={breakpoints}
                        gridItems={gridItems}
                        isMobile={isMobile}
                        isLoaded={isLoaded}
                        areFiltersApplied={areFiltersApplied}
                    />
                )}
            </ResponsiveGridWrapper>
        );
    })
);
